export default {"src":"/_next/static/image/public/images/ic_pom_badge_cards.d5cc39b3471065082f71f27300b9616d.svg","height":25,"width":85};